import React from "react";
import { ContentContainer } from "./PaymentModal.styles";
import ModalDownload from "../Modal/ModalDownload";
import PaymentsComponent from "../PaymentsComponent/PaymentsComponent";

const PaymentModal = ({
  modalRef,
  amount,
  onComplete,
  setLoading,
  loading,
  mobileCreditCard,
}) => {
  return (
    <ModalDownload
      big
      ref={modalRef}
      onClose={() => {
        modalRef.current.hide();
      }}
    >
      <ContentContainer>
        <PaymentsComponent
          blueColor
          hide
          width
          priceToPay={amount}
          setLoading={setLoading}
          loading={loading}
          onBack={() => modalRef.current.hide()}
          onComplete={onComplete}
          mobileCreditCard
        />
      </ContentContainer>
    </ModalDownload>
  );
};

export default PaymentModal;
